import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";

const DEFAULT_WIDTH = 0.6;
const DEFAULT_HEIGHT = 0.35;

const KitchenWallCabinet: C1_FurnitureDefinition = {
  id: "kitchenWallCabinet",
  icon: <C1_FurnitureIcon kind="wall-cabinet" />,
  description: { en: "Wall cabinet (Kitchen)", de: "Oberschrank (Küche)" },
  category: RoomType.Kitchen,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  autoRotate: true,
  autoReflect: true,
  grabsW: true,
  grabsH: false,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const color = strokeColor ?? "#000000";
    const lineWidth = strokeWidth ?? 2;
    const inset = 0.02 * PX;
    const detailInset = Math.min(0.06 * PX, height * 0.25);

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={rotation ?? 0}
        viewBoxWidth={width}
        viewBoxHeight={height}
        originXPercentage={0}
        originYPercentage={0}
      >
        <rect
          x={inset}
          y={inset}
          width={Math.max(0, width - inset * 2)}
          height={Math.max(0, height - inset * 2)}
          rx={inset}
          fill={fillColor ?? "#ffffff"}
          stroke={color}
          strokeWidth={lineWidth * 2}
        />
        {showDetails && (
          <>
            <line x1={width / 2} y1={inset} x2={width / 2} y2={height - inset} stroke={color} strokeWidth={lineWidth} />
            <line
              x1={inset}
              y1={height - detailInset}
              x2={width - inset}
              y2={height - detailInset}
              stroke={color}
              strokeWidth={lineWidth}
              strokeDasharray={`${0.04 * PX} ${0.03 * PX}`}
            />
          </>
        )}
      </C1_FurnitureSvg>
    );
  },
};

export default KitchenWallCabinet;
